import { TextLink } from '@cinch-labs/design-system'
import { Panel } from '@cinch-nx/landing-ui-shared'
import { SVG } from '@cinch-nx/shared-ui'
import Link from 'next/link'

import { JargonPageStoryContent } from '@cinch-nx/landing-feature-jargon'
import { StoryData } from '@storyblok/react'
import QIconComponent from '../assets/q.svg'
import styles from './related-jargon.module.css'

export interface RelatedJargonProps {
  items: StoryData<JargonPageStoryContent>[]
}

export const ArticleRelatedJargon = ({ items }: RelatedJargonProps) => (
  <div>
    {items.length > 0 &&
      items
        .filter((item) => item && item.content)
        .map((item, index) => (
          <Panel className={styles.jargon} isPadded={false} key={index}>
            <div className={styles.jargonPanelHeader}>
              <SVG
                children={QIconComponent}
                hasGradient={true}
                size={24}
                className={styles.icon}
              />
            </div>
            <h4 className={styles.jargonQuestion}>{item.content?.question}</h4>
            <div className={styles.jargonSummary}>{item.content?.summary}</div>
            <Link passHref href={`/jargon/${item.slug}`} legacyBehavior>
              <TextLink
                data-testid="jargonLink"
                className={styles.viewMoreLink}
              >
                <span>View more</span>
              </TextLink>
            </Link>
          </Panel>
        ))}
  </div>
)
